<section translate="no">
  <section style="height: auto;">
    <nav>
        <ol class="cd-breadcrumb custom-separator">
            <table>
                <tbody>
                    <tr>
                        <td class="nomeTela">
                          Cadastrado de Parametro Header
                        </td>
                    </tr>
                </tbody>
            </table>
        </ol>
    </nav>
</section>
  <main translate="no">
    <section class="main-section div_orientacao">

      <form class="form-class" data-toggle="collapse">
        <input type="text" class="form-control" id="id" name="id" [(ngModel)]="novoItem.id" required
          style="display: none;">
        <div class="form-div p-3">
          <label for="codigo" class="form-label">Id</label>
          <input type="number" class="form-control" id="id" name="id" [(ngModel)]="novoItem.id" required>
        </div>
        <div class="form-div p-3">
          <label for="codigoCentralizado" class="form-label">Width</label>
          <input type="number" class="form-control" id="width" name="width"
            [(ngModel)]="novoItem.width" required>
        </div>
        <div class="form-div p-3">
          <label for="descricao" class="form-label">Height</label>
          <input type="number" class="form-control" id="height" name="height" [(ngModel)]="novoItem.height"
            required>
          <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
        </div>
        

        <div class="form-div p-3" style="display: grid;">
            <label  for="Visualização" class="form-label">Pre-Visualização:</label>
        <img id="Visualização" name="Visualização"  [src]="'data:image/jpeg;base64,' + novoItem.foto" [width]="novoItem.width" [height]="novoItem.height">
  </div>
  <div class="form-div p-3">

            <label  for="Logo" class="form-label">Logo: <span class="obrigatorio">*</span></label>
            <input type="file" class="form-control" id="Logo" name="Logo"  (change)="onFileSelected($event)">
        </div>

        <div class="form-div p-3">

          <label  for="tipo" class="form-label">Tipo: <span class="obrigatorio">*</span></label>
          <select class="form-select" [(ngModel)]="novoItem.tipo"
                  name="tipo">
                  <option value="Junto_Sala_Situacao">Junto ao logo da Sala</option>
                </select>
      </div>

        
        

        <div class="form-div p-3">
          <label for="alt" class="form-label">ALT</label>
          <input type="text" class="form-control" id="alt" name="alt" [(ngModel)]="novoItem.alt"
            required>
          <!-- <div id="nomePosto" class="form-text">Insira o nome do posto.</div> -->
        </div>

        <!--
        <div class="form-div p-3">
          <label for="css" class="form-label">CSS</label>
          <textarea type="text" class="form-control" id="css" name="css" [(ngModel)]="novoItem.css"
            required></textarea>
        </div>

        <div class="form-div p-3">
          <label for="url_css" class="form-label">URL CSS</label>
          <input type="text" class="form-control" id="url_css" name="url_css" [(ngModel)]="novoItem.url_css"
            required>
        </div>
      -->

        <div class="form-div p-3" style=" padding-left: 56px !important; display: flex; justify-content: space-evenly;">
          <div class="form-div form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.periodoEleitoral"
              name="periodoEleitoral" id="periodoEleitoral">
            <label class="form-check-label" for="flexCheckDefault">
              Usado para o Período Eleitoral ? <span matTooltip="Selecionar se a foto deve ser usada para o período eleitoral"><i
                  class="fas fa-question-circle"></i></span>
            </label>
          </div>

          <div class="form-div form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="novoItem.ativo"
              name="ativo" id="ativo">
            <label class="form-check-label" for="flexCheckDefault">
              Ativo ?
            </label>
          </div>

        </div>



        <div class="div-button mb-3 p-3">
          <a style="margin-right: 10px;" [routerLink]="['/parametro-header-listagem']"><button id="class-button" class="btn btn-secondary">Voltar</button></a>
          <button id="class-button" style="margin-right: 10px;" (click)="Limpar()" class="btn btn-secondary">Limpar</button>
          <button id="class-button" (click)="submitForm()" class="btn btn-primary">Salvar</button>
        </div>

        

      </form>

    </section>
  </main>
</section>